import { Model } from '../abstract/model.abstract';
import { ExpertConsultationModel } from './expert-consultation.model';
import { UserExportCatalogProfileModel } from './user-export-catalog-profile.model';
import { UserExportProfileModel } from './user-export-profile.model';
import { UserPermissionModel } from './user-permission.model';
import moment from 'moment';
import { UserEnterpriseProfileModel } from './user-enterprise-profile.model';

export class UserModel extends Model {
  id: number;
  // roleId: number;
  email: string;
  createdAt: string;
  updatedAt: string;
  statusId: number;
  roles: any;
  permissions: UserPermissionModel[];

  userProfile: any;
  userEnterpriseProfile: UserEnterpriseProfileModel;
  userTwoFactor: any;
  userExportCatalogProfiles: UserExportCatalogProfileModel[];
  userExportProfiles: UserExportProfileModel[];
  consultations: ExpertConsultationModel[];
  firstConsultationCompleted: boolean;

  created: string;
  updated: string;

  get isActive(): boolean {
    return this.statusId !== 6;
  }

  get role(): string {
    return this.roles.map((el: any) => el.role.name).join(',');
  }

  override onInit() {
    super.onInit();
    this.created = moment(this.createdAt).local().format('MM-DD-YYYY H:mm');
    this.updated = moment(this.updatedAt).local().format('MM-DD-YYYY H:mm');
  }
}
